define [], () ->
  ($uibModalInstance, $scope, $http, RENTAPPLICATION_API_URL) ->
    $scope.finish_experian_verification = () ->
      $scope.adding_experian_to_all_credit_reports = true
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/landlord/add_experian_to_all_credit_reports/", 
        report_source_identifiers: ["experian_credit"]
      .then (response) ->
        $uibModalInstance.close()
      .catch (response) ->
        $uibModalInstance.dismiss("failure")
      .finally -> $scope.adding_experian_to_all_credit_reports = false





// WEBPACK FOOTER //
// ./services/experian/success/success.coffee